import React from "react";
import Logo from "../assets/metatrader.svg";
import { X } from "@phosphor-icons/react";

export default function PlatformsBox({ image = Logo, rotate = 'rotate-6', text='Meta Trader 4&5',styles }) {
  return (
    <div
      className={`relative flex justify-center items-center bg-[#181818] lg:w-[258.5px] w-fit px-11 gap-8 py-3 ${rotate} ${styles}`}
    >
      <img src={image} alt="" className="-translate-x-8" />
      <p className="text-nowrap">{text}</p>
      <div className="flex absolute top-0 right-0 h-full">
        <div className=" bg-[#181818] p-5 opacity-55  w-[70%] h-full"></div>
        <div className=" h-full  bg-[#181818]  flex justify-center items-center text-center">
          <X  size={40} />
        </div>
      </div>
    </div>
  );
}
